/** Reporting only. Never infer a historical currency from a site's country. */
export function reportCurrency(value) {
    const code = typeof value === 'string' ? value.trim().toUpperCase() : '';
    return /^[A-Z]{3}$/.test(code) ? code : null;
}
/** The sign leads the currency (-US$0.05). A caller may pass a localized fallback; English is the default. */
export function formatReportMoney(cents, currency, locale = 'en-US', fallback = 'Currency or amount not recorded') {
    const code = reportCurrency(currency);
    if (cents == null || !Number.isFinite(cents) || !code)
        return fallback;
    const amount = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(cents) / 100);
    // Same half-up rounding as Intl, so an amount printed as zero never carries a sign.
    const sign = cents < 0 && Math.round(-cents) > 0 ? '-' : '';
    return `${sign}${code === 'CAD' ? 'CA$' : code === 'USD' ? 'US$' : `${code} `}${amount}`;
}
//# sourceMappingURL=reportMoney.js.map